(function(angular, Object) {
    'use strict';

    // Add to this as necessary
    var generalNoteTypeKeys = {};
    Object.defineProperties(generalNoteTypeKeys, {
        DrugScreeningOverrideReason: readonlyProp('Medication_Override'),
        MedicationConsent: readonlyProp('MedicationConsent'),
        SigPharmacyInstructions: readonlyProp('Sig_Item'),
        SigInternalNotes: readonlyProp('SigInternal'),
        MedicalDeviceHistoryNotes: readonlyProp('MEDICALDEVICE-HISTORY'),
        DrugDiscontinueOverrideReason: readonlyProp('RX_Discontinue'),
        DrugReactionReason: readonlyProp('DrugReaction'),
        RxChangeMessageResponseComment:readonlyProp('RXChangeResponseComment'),
    });

    function readonlyProp(val) {
        return {
            value: val,
            writable: false,
            enumerable: true,
            configurable: false,
        };
    }

    angular.module('aprima-core').constant('GeneralNoteTypeKeys', generalNoteTypeKeys);

})(window.angular, window.Object);
